module.exports = __webpack_public_path__ + "static/media/card_a.b093b6ad.png";